import {
  SET_USER_DATA,
  REMOVE_USER_DATA,
  USER_LOGGED_OUT,
  GET_USER_BY_USERNAME,
  GET_ACCOUNT_BY_USERNAME,
  USER_LOADING
} from "../actions/ActionTypes";

const initialState = {
  userData: [],
  account: [],
  loading: true,
};

const userReducer = function(state = initialState, action) {
  switch (action.type) {
    case USER_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case SET_USER_DATA: {
      return {
        ...state,
        user: action.data,
        ...action.data
      };
    }
    case REMOVE_USER_DATA: {
      return {
        ...state,
        user: null
      };
    }
    case GET_USER_BY_USERNAME: {
      return {
          ...state,
          userData: [action.data],
      }
    }
    case GET_ACCOUNT_BY_USERNAME: {
      return {
          ...state,
          account: [action.data],
          loading: false
      }
    }
    case USER_LOGGED_OUT: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default userReducer;